module.exports = __webpack_public_path__ + "img/public/AdminIcons/expandUpIcon.svg?894bbe71";